export default __webpack_public_path__ + "static/media/img-5.3fad9e5a.jpg";